import { ManagedAccount } from '@webdev/user-management';
import { definedOrThrows } from '@webdev/utils';
import React, { createContext, FC, useContext, useState } from 'react';

const includesEmail = (email: string, searchString: string) => {
  if (!email) {
    return false;
  }
  return email.toLowerCase().includes(searchString.toLowerCase());
};

const context = createContext<
  | {
      searchString: string;
      setSearch: (searchString: string) => void;
      foundUsers: ManagedAccount[];
    }
  | undefined
>(undefined);
export const SearchUserContext: FC<{ users: ManagedAccount[] }> = ({ users, ...props }) => {
  const [searchString, setSearch] = useState('');

  const foundUsers = users.filter((user) => includesEmail(user.email, searchString));
  return <context.Provider value={{ setSearch, searchString, foundUsers }} {...props} />;
};

export const useSearchUserContext = () => definedOrThrows(useContext(context), 'SearchUserContext');
